import { useEffect, useRef, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { X } from "lucide-react";
import { Button } from "@/components/ui/button";
import { SearchInput } from "./SearchInput";

export function DexSearch() {
  const navigate = useNavigate();
  const { pathname } = useLocation();
  const [open, setOpen] = useState(false);
  const [draft, setDraft] = useState("");
  const panel = useRef<HTMLDivElement>(null);
  useEffect(() => { setOpen(false); }, [pathname]);
  useEffect(() => {
    const show = () => { setOpen(true); void import("@/lib/search/dex-search"); };
    const handleKey = (event: KeyboardEvent) => {
      if ((event.metaKey || event.ctrlKey) && event.key === "k") { event.preventDefault(); show(); }
      if (event.key === "Escape") setOpen(false);
    };
    const outside = (event: PointerEvent) => { if (event.target instanceof Node && !panel.current?.contains(event.target)) setOpen(false); };
    window.addEventListener("dex:open", show);
    window.addEventListener("keydown", handleKey);
    document.addEventListener("pointerdown", outside);
    return () => { window.removeEventListener("dex:open", show); window.removeEventListener("keydown", handleKey); document.removeEventListener("pointerdown", outside); };
  }, []);
  if (!open) return null;
  return <div ref={panel} className="dex-quick-search" role="region" aria-label="Quick website search">
    <div className="mb-1 flex items-center justify-between"><span className="px-2 font-mono text-xs text-foreground">Ask Jeb<span className="dex-best-pixel ml-2 inline-block" /></span><Button size="icon" variant="ghost" className="h-7 w-7" aria-label="Close search" title="Close search" onClick={() => setOpen(false)}><X className="h-3 w-3" /></Button></div>
    <SearchInput autoFocus value={draft} onChange={setDraft} onSubmit={() => { setOpen(false); navigate(`/search?q=${encodeURIComponent(draft.trim())}`); }} />
  </div>;
}
